import {NgModule} from "@angular/core";
import {CompanyAddressComponent} from "./components/company-address/company-address.component";
import {NbButtonModule, NbCardModule, NbCheckboxModule, NbDatepickerModule, NbIconModule, NbInputModule, NbPopoverModule, NbRadioModule, NbToggleModule, NbTooltipModule} from "@nebular/theme";
import {NgSelectModule} from "@ng-select/ng-select";
import {CompanyAddressFormService} from "./components/company-address/company-address-form-service";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule, DecimalPipe, TitleCasePipe} from "@angular/common";
import {CompanyHasCertificateComponent} from "./components/company-has-certificate/company-has-certificate.component";
import {CompanyHasCertificateFormService} from "./components/company-has-certificate/company-has-certificate-form.service";
import {CurrentCertificationBodyQuestionsComponent} from "./components/current-certification-body-questions/current-certification-body-questions.component";
import {CurrentCertificationBodyQuestionsFormService} from "./components/current-certification-body-questions/current-certification-body-questions-form-service";
import {CertificationBodiesResolver} from "./resolvers/certification-bodies-resolver.service";
import {ContactPersonComponent} from "./components/contact-person/contact-person.component";
import {ContactPersonFormService} from "./components/contact-person/contact-person.form.service";
import {PriceFactorsComponent} from "./components/price-factors/price-factors.component";
import {PriceFactorsFormService} from "./components/price-factors/price-factors-form.service";
import {EffectsModule} from "@ngrx/effects";
import {OrderEffects} from "./order.effects";
import {ScopesResolver} from "./resolvers/scopes.resolver";
import {ProductPricingComponent} from "./components/order-pricing/product-pricing/product-pricing.component";
import {PriceCardComponent} from "./components/order-pricing/price-card/price-card.component";
import {YearDisplayPipe} from "./components/order-pricing/price-card/year-display.pipe";
import {UmbrellaCommonModule} from "../umbrella-common/umbrella-common.module";
import {PricingSummaryComponent} from "./components/order-pricing/pricing-summary/pricing-summary.component";
import {OrderPricingComponent} from "./components/order-pricing/order-pricing.component";
import {AuditTypePipe} from "./pipes/audit-type.pipe";
import {ProductAdditionalQuestionsComponent} from "./components/additional-questions/product/product-additional-questions.component";
import {ProductAdditionalQuestionsFormService} from "./components/additional-questions/product/product-additional-questions-form.service";
import {AdditionalQuestionsResolver} from "./resolvers/additional-questions.resolver";
import {AdditionalQuestionsComponent} from "./components/additional-questions/additional-questions.component";
import {OrderDetailsComponent} from "./components/order-details/order-details.component";
import {AddressDetailsComponent} from "./components/order-details/address-details/address-details.component";
import {BooleanDisplayPipe} from "./pipes/boolean-display.pipe";
import {ContactPersonDetailsComponent} from "./components/order-details/contact-person-details/contact-person-details.component";
import {ProductDetailsComponent} from "./components/order-details/product-details/product-details.component";
import {TransferQuestionsDetailsComponent} from "./components/order-details/product-details/transfer-questions-details/transfer-questions-details.component";
import {ScopesDetailsComponent} from "./components/order-details/product-details/scopes-details/scopes-details.component";
import {CompanyDetailsComponent} from "./components/order-details/product-details/company-details/company-details.component";
import {PriceFactorsDetailsComponent} from "./components/order-details/product-details/price-factors-details/price-factors-details.component";
import {TransferDetailsComponent} from "./components/transfer-details/transfer-details.component";
import {TransferDetailsFormService} from "./components/transfer-details/transfer-details-form-service";
import {DeclineOrderButtonComponent} from "./components/decline-order-button/decline-order-button.component";
import {OutsourcedProcessComponent} from "./components/additional-questions/outsourced-process/outsourced-process.component";
import {OutsourcedProcessFormService} from "./components/additional-questions/outsourced-process/outsourced-process-form.service";
import {DatePickerComponent} from "./components/common/date-picker/date-picker.component";
import {AuditDatesComponent} from "./components/additional-questions/audit-dates/audit-dates.component";
import {InitialCertificationDatesComponent} from "./components/additional-questions/audit-dates/initial-certification-dates/initial-certification-dates.component";
import {TransferDatesComponent} from "./components/additional-questions/audit-dates/transfer-dates/transfer-dates.component";
import {AngularSvgIconModule} from "angular-svg-icon";
import {AdditionalQuestionsDetailsComponent} from "./components/additional-questions-details/additional-questions-details.component";
import {ProcessTypePipe} from "./pipes/process-type.pipe";
import {TransferAdditionalQuestionsDetailsComponent} from "./components/additional-questions-details/transfer-additional-questions-details/transfer-additional-questions-details.component";
import {InitialAdditionalQuestionsDetailsComponent} from "./components/additional-questions-details/initial-additional-questions-details/initial-additional-questions-details.component";
import {BaseAdditionalQuestionsDetailsComponent} from "./components/additional-questions-details/base-additional-question-details/base-additional-questions-details.component";
import {TransferDocumentsComponent} from "./components/transfer-documents/transfer-documents.component";
import {TransferDocumentsGroupComponent} from "./components/transfer-documents/transfer-documents-group/transfer-documents-group.component";
import {TransferDocumentsGroupInfoComponent} from "./components/transfer-documents-info/transfer-documents-group-info/transfer-documents-group-info.component";
import {TransferDocumentsInfoComponent} from "./components/transfer-documents-info/transfer-documents-info.component";
import {TotalOrderPricePipe} from "./pipes/total-order-price.pipe";
import {SelectedProductsDisplayPipe} from "./pipes/selected-products-display.pipe";
import {OrderHistoryComponent} from "./components/history/order-history.component";
import {OrderChangesComponent} from "./components/history/order-changes/order-changes.component";
import {HistoricOrderPreviewComponent} from "./components/history/order-changes/historic-order-preview/historic-order-preview.component";
import {ChangeLabelComponent} from "./components/history/change-label/change-label-component";
import {CertificateBodiesFetchService} from "./resolvers/certificate-bodies-fetch.service";
import {PriceFactorsFetchService} from "./resolvers/price-factors-fetch.service";
import {ScopesFetchService} from "./resolvers/scopes-fetch.service";
import {PricingAdjustmentsDetailsComponent} from "./components/order-pricing/pricing-adjustments-details/pricing-adjustments-details.component";
import {CountryCodesFetchService} from "./resolvers/country-codes-fetch.service";
import {CountryCodesResolver} from "./resolvers/country-codes.resolver";
import {PreAuditCheckboxComponent} from "./components/additional-questions/audit-dates/pre-audit-checkbox/pre-audit-checkbox.component";
import {TransferAuditDatesValidatorsService} from "./components/transfer-details/transfer-audit-dates-validators.service";
import {StandardSelectionComponent} from "./components/standard-selection/standard-selection.component";
import {StandardButtonComponent} from "./components/standard-selection/standard-button.component";
import {SingleNextAuditDateComponent} from "./components/additional-questions/audit-dates/single-next-audit-date/single-next-audit-date.component";
import {RecertificationAdditionalQuestionsDetailsComponent} from "./components/additional-questions-details/recertification-additional-questions-details/recertification-additional-questions-details.component";
import {AuditEventPipe} from "./pipes/audit-event.pipe";
import {StandardConfigurationsResolver} from "./resolvers/standard-configurations-resolver.service";
import {EstimateQuestionsResolver} from "./resolvers/estimate-questions.resolver";
import {EstimateQuestionsComponent} from "./components/estimate-questions/estimate-questions.component";
import {LongOptionSingleChoiceComponent} from "./components/estimate-questions/long-option-single-choice/long-option-single-choice.component";
import {EstimateQuestionsFormService} from "./components/estimate-questions/estimate-questions-form.service";
import {EstimateQuestionsDetailsComponent} from "./components/estimate-questions-details/estimate-questions-details.component";
import {LongOptionSingleChoiceDetailsComponent} from "./components/estimate-questions-details/long-option-single-choice-details/long-option-single-choice-details.component";
import {AdditionalQuestionsDataFetchResolver} from "./resolvers/additional-questions-data-fetch.resolver";
import {AdjustmentNamePipe} from "./components/order-pricing/pricing-adjustments/adjustment-name.pipe";
import {PricingAdjustmentsComponent} from "./components/order-pricing/pricing-adjustments/pricing-adjustments.component";
import {DirectPriceAdjustmentsComponent} from "./components/order-pricing/pricing-adjustments/direct-price-adjustments/direct-price-adjustments.component";
import {IntermediatePriceAdjustmentsFetchService} from "./components/order-pricing/pricing-adjustments/intermediate-price-adjustments-fetch.service";
import {PriceAdjustmentsFormService} from "./components/order-pricing/pricing-adjustments/price-adjustments-form.service";
import {IntermediatePriceAdjustmentsResolver} from "./resolvers/intermediate-price-adjustments.resolver";
import {CountriesResolver} from "./resolvers/countries.resolver";
import {ContactPersonBillingFormService} from "./components/contact-person/contact-person-billing.form.service";
import {CompanyAddressBillingFormService} from "./components/company-address/company-address-billing-form-service";
import {CompanyGeneralInfoComponent} from "./components/company-general-info/company-general-info.component";
import {EmployeesInputComponent} from "./components/company-general-info/employees-input-component/employees-input.component";
import {CompanyScopeComponent} from "./components/company-general-info/company-scope/company-scope.component";
import {ScopeToStringPipe} from "./components/company-general-info/company-scope/scope-to-string.pipe";
import {ShiftsNumberComponent} from "./components/company-general-info/shifts-number/shifts-number.component";
import {CompanyGeneralInfoFormService} from "./components/company-general-info/form-service/company-general-info.form.service";
import {CompanyDescriptionHandler} from "./components/company-general-info/form-service/company-description-handler";
import {EmployeeCountHandler} from "./components/company-general-info/form-service/employee-count-handler";
import {ScopeDescriptionHandler} from "./components/company-general-info/form-service/scope-description-handler";
import {PartTimeEmployeesHandler} from "./components/company-general-info/form-service/part-time-employees-handler";
import {CatastrophicRiskHandler} from "./components/company-general-info/form-service/catastrophic-risk-handler";
import {CompanyScopesHandler} from "./components/company-general-info/form-service/company-scopes-handler";
import {ShiftsNumberHandler} from "./components/company-general-info/form-service/shifts-number-handler";
import {COMPANY_GENERAL_INFO_FORM_CONTROL_HANDLERS} from "./components/company-general-info/form-service/form-control.handler";
import {EmployeeDetailsComponent} from "./components/order-details/product-details/employee-details/employee-details.component";
import {FullNameDisplayPipe} from "./pipes/full-name-display.pipe";
import {EstimateQuestionsFetchService} from "./resolvers/estimate-questions-fetch.service";
import {TranslateModule} from "@ngx-translate/core";
import {NbMomentDateModule} from "@nebular/moment";
import {TranslationFieldComponent} from "./translations/translation-field/translation-field-component";
import {TranslationsFormService} from "./translations/translations-form.service";
import {TranslationsHelperService} from "./translations/translations-helper.service";
import {AuditDatesFormService} from "./components/additional-questions/audit-dates/audit-dates-form.service";
import {BillingInformationComponent} from "./components/billing-information/billing-information.component";
import {DekraBillingDataComponent} from "./components/billing-information/dekra-billing-data/dekra-billing-data.component";
import {BillingInfoPreviewComponent} from "./components/billing-information/billing-info-preview/billing-info-preview.component";
import {BillingPreferencesComponent} from "./components/billing-information/billing-info-edit/billing-preferences/billing-preferences.component";
import {BillingInfoEditComponent} from "./components/billing-information/billing-info-edit/billing-info-edit.component";
import {BillingInfoFormService} from "./components/billing-information/billing-info-edit/billing-info-form.service";
import {BillingPreferencesFomService} from "./components/billing-information/billing-info-edit/billing-preferences/billing-preferences-fom.service";

@NgModule({
	imports: [
		NbCardModule,
		NgSelectModule,
		ReactiveFormsModule,
		CommonModule,
		NbInputModule,
		NbButtonModule,
		NbRadioModule,
		NbIconModule,
		NbCheckboxModule,
		NbPopoverModule,
		EffectsModule.forFeature([OrderEffects]),
		UmbrellaCommonModule,
		FormsModule,
		NbDatepickerModule,
		AngularSvgIconModule,
		NbTooltipModule,
		NbToggleModule,
		TranslateModule,
		NbMomentDateModule,
		DirectPriceAdjustmentsComponent
	],
	declarations: [
		CompanyAddressComponent,
		CompanyHasCertificateComponent,
		CurrentCertificationBodyQuestionsComponent,
		EmployeesInputComponent,
		CompanyScopeComponent,
		ScopeToStringPipe,
		ShiftsNumberComponent,
		CompanyGeneralInfoComponent,
		ContactPersonComponent,
		PriceFactorsComponent,
		EstimateQuestionsComponent,
		LongOptionSingleChoiceComponent,
		ProductPricingComponent,
		PriceCardComponent,
		YearDisplayPipe,
		PricingSummaryComponent,
		OrderPricingComponent,
		OrderDetailsComponent,
		AddressDetailsComponent,
		ContactPersonDetailsComponent,
		ProductDetailsComponent,
		TransferQuestionsDetailsComponent,
		ScopesDetailsComponent,
		CompanyDetailsComponent,
		EmployeeDetailsComponent,
		PricingAdjustmentsDetailsComponent,
		PriceFactorsDetailsComponent,
		BooleanDisplayPipe,
		ProcessTypePipe,
		AuditTypePipe,
		TransferDetailsComponent,
		AuditTypePipe,
		ProductAdditionalQuestionsComponent,
		AdditionalQuestionsComponent,
		DeclineOrderButtonComponent,
		OutsourcedProcessComponent,
		DatePickerComponent,
		AuditDatesComponent,
		InitialCertificationDatesComponent,
		TransferDatesComponent,
		AdditionalQuestionsDetailsComponent,
		TransferAdditionalQuestionsDetailsComponent,
		InitialAdditionalQuestionsDetailsComponent,
		BaseAdditionalQuestionsDetailsComponent,
		TransferDocumentsComponent,
		TransferDocumentsGroupComponent,
		TransferDocumentsGroupInfoComponent,
		TransferDocumentsInfoComponent,
		TotalOrderPricePipe,
		SelectedProductsDisplayPipe,
		OrderHistoryComponent,
		OrderChangesComponent,
		HistoricOrderPreviewComponent,
		ChangeLabelComponent,
		PreAuditCheckboxComponent,
		StandardSelectionComponent,
		StandardButtonComponent,
		SingleNextAuditDateComponent,
		RecertificationAdditionalQuestionsDetailsComponent,
		AuditEventPipe,
		EstimateQuestionsDetailsComponent,
		LongOptionSingleChoiceDetailsComponent,
		PricingAdjustmentsComponent,
		AdjustmentNamePipe,
		BillingInformationComponent,
		DekraBillingDataComponent,
		BillingInfoPreviewComponent,
		BillingPreferencesComponent,
		BillingInfoEditComponent,
		FullNameDisplayPipe,
		TranslationFieldComponent
	],
	exports: [
		CompanyAddressComponent,
		CompanyHasCertificateComponent,
		CurrentCertificationBodyQuestionsComponent,
		CompanyGeneralInfoComponent,
		ContactPersonComponent,
		PriceFactorsComponent,
		EstimateQuestionsComponent,
		LongOptionSingleChoiceComponent,
		OrderPricingComponent,
		AdditionalQuestionsComponent,
		OrderPricingComponent,
		OrderDetailsComponent,
		AddressDetailsComponent,
		ProductDetailsComponent,
		TransferQuestionsDetailsComponent,
		ContactPersonDetailsComponent,
		ScopesDetailsComponent,
		CompanyDetailsComponent,
		EmployeeDetailsComponent,
		PricingAdjustmentsDetailsComponent,
		PriceFactorsDetailsComponent,
		OrderPricingComponent,
		TransferDetailsComponent,
		DeclineOrderButtonComponent,
		DatePickerComponent,
		AdditionalQuestionsDetailsComponent,
		TransferAdditionalQuestionsDetailsComponent,
		InitialAdditionalQuestionsDetailsComponent,
		BaseAdditionalQuestionsDetailsComponent,
		AuditDatesComponent,
		ProductAdditionalQuestionsComponent,
		TransferDocumentsComponent,
		TransferDocumentsGroupComponent,
		TransferDocumentsInfoComponent,
		TotalOrderPricePipe,
		SelectedProductsDisplayPipe,
		OrderHistoryComponent,
		ChangeLabelComponent,
		ProcessTypePipe,
		BooleanDisplayPipe,
		OrderChangesComponent,
		StandardSelectionComponent,
		StandardButtonComponent,
		PricingSummaryComponent,
		ProductPricingComponent,
		SingleNextAuditDateComponent,
		ProductPricingComponent,
		RecertificationAdditionalQuestionsDetailsComponent,
		AuditTypePipe,
		AuditEventPipe,
		EstimateQuestionsDetailsComponent,
		LongOptionSingleChoiceDetailsComponent,
		BillingInformationComponent,
		DekraBillingDataComponent,
		BillingInfoPreviewComponent,
		BillingPreferencesComponent,
		BillingInfoEditComponent,
		FullNameDisplayPipe,
		TranslationFieldComponent
	],
	providers: [
		CompanyAddressFormService,
		CompanyAddressBillingFormService,
		CompanyHasCertificateFormService,
		CurrentCertificationBodyQuestionsFormService,
		CompanyGeneralInfoFormService,
		{provide: COMPANY_GENERAL_INFO_FORM_CONTROL_HANDLERS, useClass: CompanyDescriptionHandler, multi: true},
		{provide: COMPANY_GENERAL_INFO_FORM_CONTROL_HANDLERS, useClass: EmployeeCountHandler, multi: true},
		{provide: COMPANY_GENERAL_INFO_FORM_CONTROL_HANDLERS, useClass: ScopeDescriptionHandler, multi: true},
		{provide: COMPANY_GENERAL_INFO_FORM_CONTROL_HANDLERS, useClass: PartTimeEmployeesHandler, multi: true},
		{provide: COMPANY_GENERAL_INFO_FORM_CONTROL_HANDLERS, useClass: CatastrophicRiskHandler, multi: true},
		{provide: COMPANY_GENERAL_INFO_FORM_CONTROL_HANDLERS, useClass: CompanyScopesHandler, multi: true},
		{provide: COMPANY_GENERAL_INFO_FORM_CONTROL_HANDLERS, useClass: ShiftsNumberHandler, multi: true},
		CertificationBodiesResolver,
		ContactPersonFormService,
		PriceFactorsFormService,
		ContactPersonBillingFormService,
		ScopesResolver,
		EstimateQuestionsResolver,
		EstimateQuestionsFormService,
		StandardConfigurationsResolver,
		TitleCasePipe,
		ProductAdditionalQuestionsFormService,
		AdditionalQuestionsResolver,
		TransferDetailsFormService,
		OutsourcedProcessFormService,
		SelectedProductsDisplayPipe,
		TotalOrderPricePipe,
		DecimalPipe,
		CertificateBodiesFetchService,
		PriceFactorsFetchService,
		ScopesFetchService,
		CountryCodesFetchService,
		CountryCodesResolver,
		TransferAuditDatesValidatorsService,
		AuditTypePipe,
		AuditEventPipe,
		AdditionalQuestionsDataFetchResolver,
		IntermediatePriceAdjustmentsFetchService,
		PriceAdjustmentsFormService,
		IntermediatePriceAdjustmentsResolver,
		CountriesResolver,
		EstimateQuestionsFetchService,
		TranslationsFormService,
		TranslationsHelperService,
		AuditDatesFormService,
		BillingInfoFormService,
		BillingPreferencesFomService
	]
})
export class OrderModule {
}
